import React from 'react';
import { motion } from 'framer-motion';
import { Layers, Brain, Monitor, Cloud, Shield, Zap } from 'lucide-react';
import './Services.css';

const Services = () => {
  const capabilities = [
    {
      category: 'Full-Stack Systems',
      techs: ['React', 'Node.js', 'Next.js', 'Python'],
      desc: 'Scalable, high-performance architectures built for rapid business growth and reliability.',
      icon: <Layers size={24} />
    },
    {
      category: 'AI & LLM Engineering',
      techs: ['OpenAI', 'LangChain', 'Vector DBs'],
      desc: 'Intelligent automation and data-driven insights using state-of-the-art AI models.',
      icon: <Brain size={24} />
    },
    {
      category: 'Modern Web Apps',
      techs: ['Tailwind', 'Framer Motion', 'Responsive'],
      desc: 'Pixel-perfect interfaces with fluid, category-defining user experiences and animations.',
      icon: <Monitor size={24} />
    },
    {
      category: 'Cloud Infrastructure',
      techs: ['AWS', 'Docker', 'Kubernetes'],
      desc: 'Robust, cloud-native infrastructure designed for high availability and security.',
      icon: <Cloud size={24} />
    }
  ];

  return (
    <section className="services" id="services">
      <div className="services-container">
        <motion.div 
          className="services-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="sh-eyebrow">Technical Credibility</div>
          <h2 className="sh-title">Our <span>Expertise</span></h2>
        </motion.div>

        <motion.div 
          className="expertise-grid"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          {capabilities.map((item, idx) => (
            <div key={idx} className="expertise-card">
              <div className="ec-header">
                <div className="ec-icon">{item.icon}</div>
                <h3 className="ec-category">{item.category}</h3>
              </div>
              <p className="ec-desc">{item.desc}</p>
              <div className="ec-techs">
                {item.techs.map((tech, i) => (
                  <span key={i} className="ec-badge">{tech}</span>
                ))}
              </div>
              <div className="ec-bg-glow"></div>
            </div>
          ))}
        </motion.div>

        <motion.div 
          className="services-footer"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          <div className="trust-badge">
            <Shield size={16} />
            Security First
          </div>
          <div className="trust-badge">
            <Zap size={16} />
            High Performance
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
